export const SNOOZING = 'snoozing';
